// SPA-lifetime custody, independent of routed editors and modal instances.
// Store only operation metadata: never passwords, request bodies, tokens or contacts.
const records = new Map();
const listeners = new Set();
const notify = key => listeners.forEach(listener => listener(key));
const empty = Object.freeze({ pending: false, uncertain: false, emailBlocked: false });

export const staffOperations = {
  read(key) { return records.get(key) || empty; },
  begin(key, kind) {
    const current = this.read(key);
    if (!key || current.pending || current.uncertain || (kind === 'email' && current.emailBlocked)) {
      return null;
    }
    const owner = {};
    records.set(key, { ...current, pending: true, owner, kind });
    notify(key);
    return owner;
  },
  finish(key, owner, outcome) {
    const current = this.read(key);
    if (!owner || current.owner !== owner) return;
    const next = {
      pending: false,
      kind: current.kind,
      uncertain: current.uncertain || (['manual', 'authenticator'].includes(current.kind) && outcome === 'uncertain'),
      emailBlocked: current.emailBlocked ||
        (current.kind === 'email' && ['uncertain', 'daily_limit'].includes(outcome)),
    };
    if (next.uncertain || next.emailBlocked) records.set(key, next);
    else records.delete(key);
    notify(key);
  },
  reconcileAuthenticator(key, state) {
    const current = this.read(key);
    if (current.pending || current.kind !== 'authenticator' ||
      !['ready', 'pending', 'not_registered'].includes(state)) return;
    if (current.emailBlocked) records.set(key, { ...current, uncertain: false });
    else records.delete(key);
    notify(key);
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

// Test isolation only; navigation and fresh GETs must never clear custody.
export function resetStaffOperationsForTests() { records.clear(); listeners.clear(); }



// WEBPACK FOOTER //
// ./src/utils/staffOperations.js